module.exports = __webpack_public_path__ + "e26abc033a4fe7c834894c722c217a41.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2023-01-01/whats-new.html
// module id = 2341
// module chunks = 0